// extracted by mini-css-extract-plugin
export var Layout = "layout-module--Layout--d1te2";
export var aniSpin = "layout-module--ani-spin--hPbJd";
export var main = "layout-module--main--vMRgD";